import { FeedbackFormData } from 'src/modules/feedback/types/FeedbackFormData';

export const FEEDBACK_FORM_DEFAULT_DATA: FeedbackFormData = {
  rating: null,
  comment: '',
  contact: false,
};
